<div class="master-data-layout-editor mm-page">
  <header class="qa-md-header">
    <div class="qa-md-title">
      <h2>
        {{_(KEYS.MASTER_DATA.TITLE)}}
        <span class="qa-md-unsaved" *ngIf="hasUnsavedChanges">
          <i class="fa fa-circle" aria-hidden="true"></i> {{_(KEYS.MASTER_DATA.UNSAVED_CHANGES)}}
        </span>
      </h2>
      <p>{{_(KEYS.MASTER_DATA.SUBTITLE)}}</p>
    </div>
    <div class="qa-md-actions">
      <button type="button" class="btn btn-outline-secondary" (click)="onLoadDefaultLayout()">
        <i class="fa fa-magic" aria-hidden="true"></i> {{_(KEYS.MASTER_DATA.LOAD_DEFAULT)}}
      </button>
      <button type="button" class="btn btn-outline-secondary" (click)="onReset()" [disabled]="positions.length === 0">
        <i class="fa fa-undo" aria-hidden="true"></i> {{_(KEYS.MASTER_DATA.RESET)}}
      </button>
      <button type="button" class="btn btn-primary" (click)="onSave()" [disabled]="!hasUnsavedChanges || isSaving">
        <i class="fa" [ngClass]="isSaving ? 'fa-spinner fa-spin' : 'fa-save'" aria-hidden="true"></i> {{_(KEYS.MASTER_DATA.SAVE)}}
      </button>
    </div>
  </header>

  <div class="qa-md-layout">
    <!-- available fields -->
    <aside class="qa-md-palette available-fields">
      <div class="qa-md-palette-header">{{_(KEYS.MASTER_DATA.AVAILABLE_FIELDS)}}</div>

      <div class="qa-md-search field-search">
        <i class="fa fa-search" aria-hidden="true"></i>
        <input type="search" class="form-control" [(ngModel)]="fieldSearchTerm" [placeholder]="_(KEYS.MASTER_DATA.SEARCH_FIELDS)"
               [attr.aria-label]="_(KEYS.MASTER_DATA.SEARCH_FIELDS)" autocomplete="off" spellcheck="false">
      </div>

      <div class="qa-md-palette-scroll available-fields-scroll">
        <div class="fields-section">
          <div class="fields-section-header"><span class="qa-md-dot qa-md-dot-standard"></span>{{_(KEYS.MASTER_DATA.STANDARD_FIELDS)}}</div>
          <div class="available-fields-list" [dragula]="'master-data-fields'">
            <div *ngFor="let def of filteredStandardFields" class="available-field drag-handle field-type-standard"
                 [attr.data-field-key]="def.key" [attr.data-field-type]="'standard'">
              <i class="fa fa-arrows" aria-hidden="true"></i>
              <span>{{_(KEYS.CRUD[def.labelKey] || def.labelKey)}}</span>
            </div>
          </div>
          <div *ngIf="availableStandardFields.length === 0" class="qa-md-empty">{{_(KEYS.MASTER_DATA.ALL_STANDARD_PLACED)}}</div>
          <div *ngIf="availableStandardFields.length > 0 && filteredStandardFields.length === 0" class="qa-md-empty">{{_(KEYS.MASTER_DATA.NO_SEARCH_RESULTS)}}</div>
        </div>

        <div class="fields-section">
          <div class="fields-section-header"><span class="qa-md-dot qa-md-dot-custom"></span>{{_(KEYS.MASTER_DATA.CUSTOM_FIELDS)}}</div>
          <div class="available-fields-list" [dragula]="'master-data-fields'">
            <div *ngFor="let def of filteredCustomFields" class="available-field drag-handle field-type-custom"
                 [attr.data-field-key]="def.key" [attr.data-field-type]="'custom'">
              <i class="fa fa-arrows" aria-hidden="true"></i>
              <span>{{def.label}}</span>
            </div>
          </div>
          <div *ngIf="customDefinitions.length === 0" class="qa-md-empty">{{_(KEYS.MASTER_DATA.NO_CUSTOM_FIELDS)}}</div>
          <div *ngIf="customDefinitions.length > 0 && availableCustomFields.length === 0" class="qa-md-empty">{{_(KEYS.MASTER_DATA.ALL_CUSTOM_PLACED)}}</div>
          <div *ngIf="availableCustomFields.length > 0 && filteredCustomFields.length === 0" class="qa-md-empty">{{_(KEYS.MASTER_DATA.NO_SEARCH_RESULTS)}}</div>
        </div>

        <!-- dividers can be placed multiple times -->
        <div class="fields-section" *ngIf="showHrDivider">
          <div class="fields-section-header"><span class="qa-md-dot qa-md-dot-hr"></span>{{_(KEYS.MASTER_DATA.ELEMENTS)}}</div>
          <div class="available-fields-list" [dragula]="'master-data-fields'">
            <div class="available-field drag-handle field-type-hr" data-field-key="hr" data-field-type="hr">
              <i class="fa fa-arrows" aria-hidden="true"></i>
              <span>{{_(KEYS.MASTER_DATA.HR_DIVIDER)}}</span>
            </div>
          </div>
        </div>
      </div>
    </aside>

    <!-- form layout -->
    <section class="qa-md-canvas">
      <div class="qa-md-toolbar">
        <div class="qa-md-toolbar-title">{{_(KEYS.MASTER_DATA.FORM)}}</div>
        <div class="qa-md-mode" role="tablist" [attr.aria-label]="_(KEYS.MASTER_DATA.FORM)">
          <button type="button" role="tab" [attr.aria-selected]="!previewMode" [class.active]="!previewMode" (click)="previewMode = false">
            <i class="fa fa-th" aria-hidden="true"></i> {{_(KEYS.MASTER_DATA.EDIT_MODE)}}
          </button>
          <button type="button" role="tab" [attr.aria-selected]="previewMode" [class.active]="previewMode" (click)="previewMode = true">
            <i class="fa fa-eye" aria-hidden="true"></i> {{_(KEYS.MASTER_DATA.PREVIEW)}}
          </button>
        </div>
        <div class="qa-md-legend" *ngIf="!previewMode" aria-hidden="true">
          <span><span class="qa-md-dot qa-md-dot-standard"></span>{{_(KEYS.MASTER_DATA.STANDARD_FIELDS)}}</span>
          <span><span class="qa-md-dot qa-md-dot-custom"></span>{{_(KEYS.MASTER_DATA.CUSTOM_FIELDS)}}</span>
          <span><span class="qa-md-dot qa-md-dot-hr"></span>{{_(KEYS.MASTER_DATA.HR_DIVIDER)}}</span>
        </div>
        <label class="qa-md-gridsize" *ngIf="!previewMode">
          <span>{{_(KEYS.MASTER_DATA.GRID_SIZE)}}</span>
          <select class="form-control" (change)="onGridSizeChange(gridPresets[$event.target.selectedIndex])">
            <option *ngFor="let preset of gridPresets" [selected]="isGridSizeSelected(preset)">{{getGridSizeLabel(preset)}}</option>
          </select>
        </label>
      </div>

      <p class="qa-md-hint" *ngIf="!previewMode"><i class="fa fa-info-circle" aria-hidden="true"></i> {{_(KEYS.MASTER_DATA.HINT)}}</p>

      <div class="grid-layout-area-container" *ngIf="!previewMode">
        <div class="grid-container"
             [style.grid-template-columns]="'repeat(' + gridSize.cols + ', minmax(0, 1fr))'"
             [style.grid-template-rows]="'repeat(' + gridSize.rows + ', 36px)'">
          <ng-container *ngFor="let row of range(gridSize.rows)">
            <ng-container *ngFor="let col of range(gridSize.cols)">
              <!-- empty cell (drop target) -->
              <!-- explicit cell position, so the move frame lays over free cells instead of pushing them into a new row -->
              <div *ngIf="!getFieldAt(col, row)" class="grid-cell empty"
                   [style.grid-column]="col + 1" [style.grid-row]="row + 1"
                   [attr.data-col]="col" [attr.data-row]="row" [dragula]="'master-data-fields'"></div>

              <!-- placed field, rendered at its start position -->
              <div *ngIf="isFieldStart(col, row)" class="grid-cell occupied field-cell"
                   [ngClass]="getFieldTypeClass(getFieldAt(col, row))"
                   [class.qa-md-moving]="getFieldAt(col, row) === movingField"
                   (mousedown)="onMoveStart($event, getFieldAt(col, row))"
                   [style.grid-column]="(col + 1) + ' / span ' + getFieldAt(col, row)?.colSpan"
                   [style.grid-row]="(row + 1) + ' / span ' + getFieldAt(col, row)?.rowSpan">
                <div class="field-content">
                  <span class="field-label">{{getFieldLabel(getFieldAt(col, row))}}</span>
                  <!-- no input placeholder (the preview shows the real form), only the divider keeps its line -->
                  <span class="qa-md-field-input" *ngIf="getFieldAt(col, row)?.fieldType === 'hr'" aria-hidden="true"></span>
                  <button type="button" class="qa-md-remove" (click)="onRemoveField(getFieldAt(col, row))"
                          [attr.title]="_(KEYS.MASTER_DATA.REMOVE)" [attr.aria-label]="_(KEYS.MASTER_DATA.REMOVE)">
                    <i class="fa fa-times" aria-hidden="true"></i>
                  </button>
                  <div class="resize-handle" (mousedown)="onResizeStart($event, getFieldAt(col, row))"
                       [attr.title]="_(KEYS.MASTER_DATA.RESIZE)"></div>
                </div>
              </div>
            </ng-container>
          </ng-container>

          <!-- target area while moving a placed field -->
          <div *ngIf="movingField && moveTarget" class="qa-md-move-target" [class.qa-md-move-invalid]="!moveTarget.valid"
               [style.grid-column]="(moveTarget.col + 1) + ' / span ' + movingField.colSpan"
               [style.grid-row]="(moveTarget.row + 1) + ' / span ' + movingField.rowSpan">
            <span>{{getFieldLabel(movingField)}}</span>
          </div>
        </div>
      </div>

      <!-- preview: the patient form as it renders with the current, also unsaved layout -->
      <div class="qa-md-preview" *ngIf="previewMode">
        <p class="qa-md-hint">
          <i class="fa fa-info-circle" aria-hidden="true"></i>
          {{previewLayoutIsDefault ? _(KEYS.MASTER_DATA.PREVIEW_DEFAULT) : _(KEYS.MASTER_DATA.PREVIEW_HINT)}}
        </p>
        <div class="qa-md-preview-sheet">
          <form class="master-data-form" (submit)="$event.preventDefault()">
            <div class="master-data-grid" [style.grid-template-columns]="masterDataLayoutService.getGridTemplateColumns(previewLayout)">
              <ng-container *ngFor="let position of previewLayout.positions">
                <div *ngIf="position.fieldType === 'hr'" class="grid-field-cell hr-cell"
                     [style.grid-column]="masterDataLayoutService.getGridColumn(position)" [style.grid-row]="masterDataLayoutService.getGridRow(position)">
                  <hr>
                </div>

                <div *ngIf="position.fieldType === 'standard'" class="grid-field-cell form-group" [ngSwitch]="position.fieldKey"
                     [style.grid-column]="masterDataLayoutService.getGridColumn(position)" [style.grid-row]="masterDataLayoutService.getGridRow(position)">
                  <ng-container *ngSwitchCase="'address'">
                    <div class="address-deprecated"><label>{{getFieldLabel(position)}}:&nbsp;</label><span>–</span><hr></div>
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    <label [title]="getFieldLabel(position)">
                      {{getFieldLabel(position)}}
                      <i *ngIf="position.fieldKey === 'locale'" class="fa fa-flag" aria-hidden="true"></i>
                      <i *ngIf="position.fieldKey === 'allowMail' || position.fieldKey === 'prefill'" class="fa fa-info-circle" aria-hidden="true"></i>
                    </label>
                    <ng-container [ngSwitch]="position.fieldKey">
                      <select *ngSwitchCase="'gender'" class="form-control">
                        <option>{{_(KEYS.MASTER_DATA.CHOOSE)}}</option>
                        <option>{{_(KEYS.CRUD.MALE)}}</option><option>{{_(KEYS.CRUD.FEMALE)}}</option><option>{{_(KEYS.CRUD.DIVERSE)}}</option>
                      </select>
                      <select *ngSwitchCase="'locale'" class="form-control"><option>{{_(KEYS.MASTER_DATA.DEFAULT_LANGUAGE)}}</option></select>
                      <select *ngSwitchCase="'allowMail'" class="form-control">
                        <option>{{_(KEYS.CRUD.YES)}}</option><option selected>{{_(KEYS.CRUD.NO)}}</option>
                      </select>
                      <select *ngSwitchCase="'prefill'" class="form-control">
                        <option>{{_(KEYS.CRUD.YES)}}</option><option selected>{{_(KEYS.CRUD.NO)}}</option><option>{{_(KEYS.CRUD.OPTIONAL)}}</option>
                      </select>
                      <input *ngSwitchDefault class="form-control" [placeholder]="getPreviewPlaceholder(position)">
                    </ng-container>
                  </ng-container>
                </div>

                <ng-container *ngIf="position.fieldType === 'custom'">
                  <div *ngIf="getCustomDefinition(position.fieldKey) as def" class="grid-field-cell form-group"
                       [style.grid-column]="masterDataLayoutService.getGridColumn(position)" [style.grid-row]="masterDataLayoutService.getGridRow(position)">
                    <label [title]="def.label">{{def.label}}</label>
                    <ng-container [ngSwitch]="def.type">
                      <input *ngSwitchCase="'number'" type="number" class="form-control">
                      <input *ngSwitchCase="'date'" type="date" class="form-control">
                      <select *ngSwitchCase="'select'" class="form-control">
                        <option>-</option>
                        <option *ngFor="let opt of def.options">{{opt.label}}</option>
                      </select>
                      <select *ngSwitchCase="'boolean'" class="form-control">
                        <option>{{_(KEYS.CRUD.NO)}}</option><option>{{_(KEYS.CRUD.YES)}}</option>
                      </select>
                      <input *ngSwitchDefault type="text" class="form-control">
                    </ng-container>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</div>
